import { observer } from "mobx-react";
import RmaShipmentStore from "../../../../stores/rma-shipment-store";
import GridLine from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import RmaPageStore from "../../../../stores/rma-page-store";
import LabelOrSlipsCell from "../label-or-slips-cell/label-or-slips-cell";
import SlipsCell from "../slips-cell/slips-cell";

interface IProps {
    shipment: RmaShipmentStore;
    rmaPageStore: RmaPageStore;
};

const ShipmentWithAnyCarrier: React.FC<IProps> = observer(({ shipment, rmaPageStore }) => {
    return (
        <GridLine
            settings={{
                columns: [{ width: 3 }, {width: 2 }, { width: 13 }]
            }}
            columns={[
                <GridLineItem>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{shipment.returnMethodName}</FontBody1>
                </GridLineItem>,

                <GridLineItem>
                    <LabelOrSlipsCell content={shipment.labelContent()} rmaPageStore={rmaPageStore} />
                </GridLineItem>,
                <GridLineItem>
                    <SlipsCell shipment={shipment} rmaPageStore={rmaPageStore} />
                </GridLineItem>,
            ]} />
    );
});
export default ShipmentWithAnyCarrier;